import PadListPage from './padListPage';

export default PadListPage;
